/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const revealsSlow = document.querySelectorAll('.reveal-slow');
const stagger = document.querySelectorAll('.stagger');

if (typeof enterView === 'function') {
  if (reveals.length > 0) {
    enterView({
      selector: '.reveal',
      enter: (el, i) => {
        el.classList.add('entered');
      },
      exit: el => {
        el.classList.remove('entered');
      },
      offset: 0.1
    });
  }

  if (revealsSlow.length > 0) {
    enterView({
      selector: '.reveal-slow',
      enter: (el, i) => {
        el.classList.add('entered');
      },
      exit: el => {
        el.classList.remove('entered');
      },
      offset: 0.1
    });
  }
} else {
  reveals.forEach(el => el.classList.add('entered'));
  revealsSlow.forEach(el => el.classList.add('entered'));
}

if (stagger.length > 0) {
  stagger.forEach(el => {
    el.querySelectorAll('.stagger-child').forEach((e, i) => {
      e.style.setProperty('--animation-order', i);
    });
  });
}

function whenSwiperReady(callback) {
  if (typeof callback !== 'function') return;

  const run = () => {
    if (typeof Swiper === 'function') {
      callback();
      return true;
    }
    return false;
  };

  if (run()) return;

  let attempts = 0;
  const poll = () => {
    if (run() || attempts++ > 100) return;
    setTimeout(poll, 50);
  };
  poll();
}

function createSwiper(el, options) {
  if (typeof Swiper !== 'function') return null;
  const target = typeof el === 'string' ? document.querySelector(el) : el;
  if (!target || target.swiper) return null;
  return new Swiper(target, options);
}

function updateAllSwipers() {
  document.querySelectorAll('.swiper-initialized').forEach(el => {
    if (el.swiper && typeof el.swiper.update === 'function') {
      el.swiper.update();
    }
  });
}

window.whenSwiperReady = whenSwiperReady;
window.createSwiper = createSwiper;

/* Swiper Initialiser */
function initThemeSwipers() {
const swiperContainerP = document.getElementsByClassName(
  'carousel_product'
);
for (var i = 0; i < swiperContainerP.length; i++) {
  swiperContainerP[i].classList.add('swiperP' + i);

  const swiperPage = swiperContainerP[i].querySelector(
    '.swiper-pagination'
  );

  if (swiperPage) {
    swiperPage.classList.add('pageP' + i);
  }

  const carouselEl = swiperContainerP[i].closest('.product__carousel');
  const isThumbnailCarousel = carouselEl?.classList.contains(
    'product__carousel--carousel_thumbnails'
  );
  const isGridCarousel = carouselEl?.classList.contains(
    'product__carousel--grid'
  );
  const isBundleCarousel = !!swiperContainerP[i].closest('.bundle-product');

  if ((isThumbnailCarousel || isGridCarousel) && !isBundleCarousel) {
    continue;
  }

  window.productSwiper = createSwiper('.swiperP' + i, {
    direction: 'horizontal',
    loop: false,
    autoHeight: false,
    slidesPerView: 1,
    spaceBetween: isBundleCarousel ? 2 : 0,
    speed: 300,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-product-button-next',
      prevEl: '.swiper-product-button-prev'
    },
    pagination: {
      el: '.pageP' + i,
      clickable: true
    },
    on: {
      slideChange(swiper) {
        if (typeof window.syncProductThumbnailsFromSwiper === 'function') {
          window.syncProductThumbnailsFromSwiper(swiper);
        }
      }
    }
  });
}

if (typeof window.initProductSwiper === 'function') {
  window.initProductSwiper();
}

if (typeof window.initProductThumbnails === 'function') {
  window.initProductThumbnails();
}

if (typeof window.watchProductMobileCarousels === 'function') {
  window.watchProductMobileCarousels();
} else if (typeof window.initProductMobileThumbs === 'function') {
  window.initProductMobileThumbs();
}

var heroCarouselEl = document.querySelector('.banner-carousel');
var heroSlideCount = heroCarouselEl
  ? heroCarouselEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length
  : 0;
var heroCarousel = createSwiper(heroCarouselEl, {
  loop: heroSlideCount > 1,
  autoplay: heroSlideCount > 1 ? { delay: 5000, disableOnInteraction: false } : false,
  pagination: {
    el: heroCarouselEl
      ? heroCarouselEl.querySelector('.swiper-pagination')
      : null,
    clickable: true
  },
  watchOverflow: true
});

var swiperImpact = new Swiper('#impactSlider', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 12,
  slidesOffsetBefore: 12,
  slidesOffsetAfter: 12,
  navigation: {
    nextEl: '.swiper-impact-button-next',
    prevEl: '.swiper-impact-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16
    },
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16
    }
  }
});

// Dark bg modular impact section
const impactSliders = document.querySelectorAll(
  '[data-impact-slider]'
);

impactSliders.forEach(sliderEl => {
  const id = sliderEl.getAttribute('data-impact-slider');

  createSwiper(sliderEl, {
    direction: 'horizontal',
    slidesPerView: 1.2,
    spaceBetween: 12,
    slidesOffsetBefore: 12,
    slidesOffsetAfter: 12,
    navigation: {
      nextEl: `[data-next="${id}"]`,
      prevEl: `[data-prev="${id}"]`
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      }
    }
  });
});

var imageCarousel = new Swiper('#imageCarousel', {
  direction: 'horizontal',
  slidesPerView: 1.2,
  spaceBetween: 12,
  slidesOffsetBefore: 12,
  slidesOffsetAfter: 12,
  navigation: {
    nextEl: '.swiper-impact-button-next',
    prevEl: '.swiper-impact-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16
    },
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 16,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24
    }
  }
});

var swiperHowItWorks = new Swiper('#howItWorksSlider', {
  direction: 'horizontal',
  slidesPerView: 1.5,
  spaceBetween: 12,
  slidesOffsetBefore: 12,
  slidesOffsetAfter: 12,
  navigation: {
    nextEl: '.swiper-how-it-works-button-next',
    prevEl: '.swiper-how-it-works-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 3.5,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 16,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0
    }
  }
});

var swiperFeaturedCollections = new Swiper(
  '#featuredCollectionsSlider',
  {
    direction: 'horizontal',
    slidesPerView: 1.15,
    spaceBetween: 12,
    slidesOffsetBefore: 12,
    slidesOffsetAfter: 12,
    navigation: {
      nextEl: '.swiper-featured-collections-button-next',
      prevEl: '.swiper-featured-collections-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  }
);

var swiperFeaturedCollection = new Swiper(
  '#featuredCollectionSlider',
  {
    direction: 'horizontal',
    slidesPerView: 1.3,
    spaceBetween: 12,
    slidesOffsetBefore: 12,
    slidesOffsetAfter: 12,
    navigation: {
      nextEl: '.swiper-featured-collection-button-next',
      prevEl: '.swiper-featured-collection-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  }
);

window.cartUpsellSwiper = new Swiper('#cartUpsellSwiper', {
  direction: 'horizontal',
  slidesPerView: 1.1,
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-upsell-button-next',
    prevEl: '.swiper-upsell-button-prev'
  },
  breakpoints: {
    450: {
      slidesPerView: 1.3
    }
  }
});

var specificationsCarousel = new Swiper('#specificationsCarousel', {
  direction: 'horizontal',
  slidesPerView: 2.5,
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-specifications-carousel-button-next',
    prevEl: '.swiper-specifications-carousel-button-prev'
  }
});

var swiperAccordion = new Swiper('#accordionSwiper', {
  direction: 'horizontal',
  slidesPerView: 2.5,
  spaceBetween: 16,
  navigation: {
    nextEl: '.swiper-accordion-button-next',
    prevEl: '.swiper-accordion-button-prev'
  }
});

var tabContentSwiper = new Swiper('.tab-content__swiper', {
  direction: 'horizontal',
  slidesPerView: 1,
  centeredSlides: false,
  loop: false,
  spaceBetween: 40,
  navigation: {
    nextEl: '.swiper-tab-content-button-next',
    prevEl: '.swiper-tab-content-button-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    }
  }
});

const sliders = document.querySelectorAll('.b2b-swiper');

sliders.forEach(slider => {
  createSwiper(slider, {
    slidesPerView: 1.2,
    spaceBetween: 16,
    slidesOffsetBefore: 12,
    slidesOffsetAfter: 12,
    grabCursor: true,

    navigation: {
      nextEl: slider.querySelector('.b2b-swiper-next'),
      prevEl: slider.querySelector('.b2b-swiper-prev')
    },

    breakpoints: {
      768: {
        slidesPerView: 3.2,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24
      },
      1024: {
        slidesPerView: 4.2,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24
      }
    }
  });
});
}

whenSwiperReady(initThemeSwipers);
window.addEventListener('load', updateAllSwipers);

function initProductCardSwipers(root = document) {
  whenSwiperReady(() => {
    const cards = root.querySelectorAll('.pcard__carousel .swiper');

    cards.forEach(swiperEl => {
      if (swiperEl.querySelectorAll('.swiper-slide').length < 2) return;

      createSwiper(swiperEl, {
        slidesPerView: 1,
        loop: false,
        allowTouchMove: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev')
        },
        observeParents: true,
        observer: true,
        resizeObserver: true
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductCardSwipers();
});

window.initProductCardSwipers = initProductCardSwipers;

// Cart ATC FUNCTIONALITY
const optionSelect = document.querySelector(
  '.pcard--cart [data-purchase-type-select]'
);
const subscriptionSelect = document.querySelector(
  '.pcard--cart [data-subsciption-select]'
);
const variantSelect = document.querySelector(
  '.pcard--cart [data-variant-select'
);
const sellingPlanInput = document.querySelector(
  '.pcard--cart #sellingPlanSelect'
);

const regPrice = document.querySelector(
  '.pcard--cart .product-card__normal-price'
);
const subPrice = document.querySelector(
  '.pcard--cart .product-card__sub-price'
);

const selects = document.querySelectorAll(
  '.pcard--cart .product-card__option-select-container'
);

if (optionSelect) {
  optionSelect.addEventListener('change', e => {
    const value = e.target.value;

    if (value == 'oneOff') {
      subscriptionSelect.style.display = 'none';
      subPrice.style.display = 'none';
      sellingPlanInput.name = '';
      regPrice.classList.add('product-card__normal-price--regular');
    } else if (value == 'subscription') {
      subscriptionSelect.style.display = 'flex';
      subPrice.style.display = 'block';
      sellingPlanInput.name = 'selling_plan';
      regPrice.classList.remove(
        'product-card__normal-price--regular'
      );
    }
  });
}

if (variantSelect) {
  variantSelect.addEventListener('change', e => {
    const el = e.target.options[e.target.selectedIndex];
    const elPrice = el.dataset.price;
    const elSubPrice = el.dataset.subPrice;

    regPrice.innerHTML = formatMoney(regPrice.innerHTML, elPrice);
    regPrice.dataset.price = elPrice;

    if (elSubPrice) {
      subPrice.innerHTML = formatMoney(
        regPrice.innerHTML,
        elSubPrice
      );
      subPrice.dataset.price = elSubPrice;
    }
  });
}

// Product Card Atc Forms Open / Close
let productCardAtc = document.querySelectorAll('[data-card-atc]');

function listenersToCards() {
  productCardAtc.forEach(atc => {
    const card = atc.closest('.pcard');
    const form = card.querySelector('.product-card__atc-form');
    const closeBtn = card.querySelector(
      '.product-card__atc-form-close-btn'
    );
    const quantity = card.querySelector('.product-card__quantity');
    const btns = card.querySelectorAll('.product-card__quantity-btn');
    const optionSelect = card.querySelector(
      '[data-purchase-type-select]'
    );
    const subscriptionSelect = card.querySelector(
      '[data-subsciption-select]'
    );
    const variantSelect = card.querySelector('[data-variant-select');
    const sellingPlanInput = card.querySelector('#sellingPlanSelect');

    const regPrice = card.querySelector(
      '.product-card__normal-price'
    );
    const subPrice = card.querySelector('.product-card__sub-price');

    const selects = form.querySelectorAll(
      '.product-card__option-select-container'
    );

    atc.addEventListener('click', e => {
      e.preventDefault();

      form.classList.add('active');
      if (selects) {
        selects.forEach(select => {
          select.addEventListener('click', e => {
            e.preventDefault();
          });
        });
      }
    });

    card.addEventListener('mouseleave', () => {
      form.classList.remove('active');
    });

    btns.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        changeCardQuantity(card, btn.name);
      });
    });

    closeBtn.addEventListener('click', e => {
      e.preventDefault();
      form.classList.remove('active');
    });

    quantity.addEventListener('click', e => {
      e.preventDefault();
    });

    if (optionSelect) {
      optionSelect.addEventListener('change', e => {
        const value = e.target.value;

        if (value == 'oneOff') {
          subscriptionSelect.style.display = 'none';
          subPrice.style.display = 'none';
          sellingPlanInput.name = '';
          regPrice.classList.add(
            'product-card__normal-price--regular'
          );
        } else if (value == 'subscription') {
          subscriptionSelect.style.display = 'flex';
          subPrice.style.display = 'block';
          sellingPlanInput.name = 'selling_plan';
          regPrice.classList.remove(
            'product-card__normal-price--regular'
          );
        }
      });
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', e => {
        const el = e.target.options[e.target.selectedIndex];
        const elPrice = el.dataset.price;
        const elSubPrice = el.dataset.subPrice;

        const quantityAmount = quantity.querySelector('input').value;

        regPrice.innerHTML = formatMoney(
          regPrice.innerHTML,
          elPrice,
          quantityAmount
        );
        regPrice.dataset.price = elPrice;

        if (elSubPrice) {
          subPrice.innerHTML = formatMoney(
            regPrice.innerHTML,
            elSubPrice,
            quantityAmount
          );
          subPrice.dataset.price = elSubPrice;
        }
      });
    }
  });
}

listenersToCards();

// MOBILE VIEWPORT HEIGHT FIX
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');

    console.log('here', button);
  });
});

/* Change Product Quantity */
function changeQuantity(formId, quantity) {
  var formQ = document.querySelector(formId);
  if (!formQ) return;

  var oldValue = formQ.value;

  if (quantity == '+') {
    Number(formQ.value++);
  } else if (quantity == '-' && formQ.value > 1) {
    Number(formQ.value--);
  }

  // Programmatic .value mutation doesn't trigger an input event by itself.
  // Dispatching one here lets any input listeners (qty toggle, stock check)
  // react without needing their own +/- click handlers and timeouts.
  if (formQ.value !== oldValue) {
    formQ.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* Details Animator */
const details = document.querySelectorAll('details');

if (details) {
  details.forEach(targetDetail => {
    targetDetail.addEventListener('click', function (e) {
      if (!targetDetail.hasAttribute('open')) return;
      if (!e.target.closest('summary')) return;

      e.preventDefault();
      targetDetail.classList.add('closing');
      setTimeout(() => {
        targetDetail.removeAttribute('open');
        targetDetail.classList.remove('closing');
      }, 390);
    });
  });
}

/* Hold non-LCP images until fully decoded so progressive JPEG/WebP does not paint in scans */
function revealWhenDecoded(img) {
  if (img.getAttribute('fetchpriority') === 'high') {
    img.classList.add('is-decoded');
    return;
  }

  const show = () => img.classList.add('is-decoded');
  img.classList.add('js-decode-hold');

  const settle = () => {
    if (typeof img.decode === 'function') {
      img.decode().then(show).catch(show);
    } else {
      show();
    }
  };

  if (img.complete) {
    settle();
    return;
  }

  img.addEventListener('load', settle, { once: true });
  img.addEventListener('error', show, { once: true });
}

document.querySelectorAll('.media-img').forEach(revealWhenDecoded);

/* Lazy Load Initialiser */
var lazyLoadInstance =
  typeof LazyLoad === 'function' ? new LazyLoad({}) : null;

/* Liquid Ajax Cart */

if (typeof liquidAjaxCart !== 'undefined') {
liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'ADDING';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);
}

/* enterview */
/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy');

if (llVideos.length > 0 && typeof enterView === 'function') {
  enterView({
    selector: '.video-ll',
    enter: function (el) {
      el.load();
      el.play();
    },
    offset: 0.1
  });
}

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', handleAccountPageNav);
window.addEventListener('hashchange', handleAccountPageNav);

// Product card
function getProductCardColourOptionIndex(options) {
  return options.findIndex(opt => /colou?r/i.test(opt));
}

function findProductCardVariantForColour(product, colourOptionIndex, colourValue) {
  const variants = product.variants.filter(
    v => v[`option${colourOptionIndex + 1}`] === colourValue
  );

  return variants.find(v => v.available) || variants[0];
}

function getProductCardVariantsForPrice(product, variant) {
  if (!product?.variants?.length) return variant ? [variant] : [];

  const inStock = product.variants.filter(v => v.available);
  return inStock.length ? inStock : product.variants;
}

function ensureProductCardPriceElements(priceContainer) {
  let priceOg = priceContainer.querySelector('.pcard__price-og');
  if (!priceOg) {
    priceOg = document.createElement('p');
    priceOg.className = 'pcard__price-og';
    priceContainer.prepend(priceOg);
  }

  let fromEl = priceOg.querySelector('.pcard__price-from');
  let amountEl = priceOg.querySelector('.pcard__price-amount');

  if (!fromEl || !amountEl) {
    priceOg.innerHTML =
      '<span class="pcard__price-from" hidden></span><span class="pcard__price-amount"></span>';
    fromEl = priceOg.querySelector('.pcard__price-from');
    amountEl = priceOg.querySelector('.pcard__price-amount');
  }

  return { priceOg, fromEl, amountEl };
}

function setProductCardFromPrefix(fromEl, show, label) {
  if (!fromEl) return;
  fromEl.textContent = show ? label : '';
  fromEl.hidden = !show;
}

function productCardPricesVary(card, product, variants) {
  const variantPrices = variants.map(item => Number(item.price));
  if (!card.closest('[data-plp-card]')) return new Set(variantPrices).size > 1;

  const colourOptionIndex = getProductCardColourOptionIndex(product.options || []);
  if (colourOptionIndex === -1) return new Set(variantPrices).size > 1;

  const optionKey = `option${colourOptionIndex + 1}`;
  const pricesByColour = new Map();
  variants.forEach(item => {
    const colour = String(item[optionKey] || '').trim().toLowerCase();
    const price = Number(item.price);
    if (!pricesByColour.has(colour)) pricesByColour.set(colour, new Set());
    pricesByColour.get(colour).add(price);
  });

  const signatures = Array.from(pricesByColour.values()).map(prices =>
    Array.from(prices).sort((a, b) => a - b).join(',')
  );
  return new Set(signatures).size > 1;
}

function updateProductCardPrice(card, variant, product) {
  const priceContainer = card.querySelector('.pcard__price');
  if (!priceContainer || !variant) return;

  const isBundle = priceContainer.dataset.isBundle === 'true';
  const bundlePct = parseFloat(priceContainer.dataset.bundleDiscount) || 12.5;
  const fromLabel = priceContainer.dataset.fromLabel || 'From';

  // Liberty colourways are excluded from the bundle discount. The id list is rendered by product-card.liquid
  const libertyIds = (priceContainer.dataset.libertyVariants || '')
    .split(',')
    .filter(Boolean);
  const variantIsLiberty = libertyIds.includes(String(variant.id));

  const variantsForPrice = getProductCardVariantsForPrice(product, variant);
  const prices = variantsForPrice.map(item => Number(item.price));
  const minPrice = prices.length ? Math.min(...prices) : Number(variant.price);
  const priceVaries = productCardPricesVary(card, product, variantsForPrice);
  const displayVariant =
    variantsForPrice.find(v => Number(v.price) === minPrice) || variant;

  const { fromEl, amountEl } = ensureProductCardPriceElements(priceContainer);
  let priceSale = priceContainer.querySelector('.pcard__price-sale');

  if (isBundle && !variantIsLiberty) {
    const discountedPrice = Math.round(minPrice * ((100 - bundlePct) / 100));

    if (!priceSale) {
      priceSale = document.createElement('p');
      priceSale.className = 'pcard__price-sale';
      priceSale.style.cssText = 'text-decoration: line-through; opacity: 0.6;';
      priceContainer.appendChild(priceSale);
    }

    setProductCardFromPrefix(fromEl, priceVaries, fromLabel);
    amountEl.textContent = formatMoney(discountedPrice);
    priceSale.textContent = formatMoney(minPrice);
    priceSale.style.display = '';
    return;
  }

  setProductCardFromPrefix(fromEl, priceVaries, fromLabel);
  amountEl.textContent = formatMoney(minPrice);

  if (!priceVaries && displayVariant.compare_at_price > displayVariant.price) {
    if (!priceSale) {
      priceSale = document.createElement('p');
      priceSale.className = 'pcard__price-sale';
      priceSale.style.cssText = 'text-decoration: line-through; opacity: 0.6;';
      priceContainer.appendChild(priceSale);
    }

    priceSale.textContent = formatMoney(displayVariant.compare_at_price);
    priceSale.style.display = '';
  } else if (priceSale) {
    priceSale.style.display = 'none';
  }
}

const prefetchedProductCardImages = new Set();

function prefetchProductCardImage(url) {
  if (!url || prefetchedProductCardImages.has(url)) return;

  prefetchedProductCardImages.add(url);
  const img = new Image();
  img.decoding = 'async';
  img.src = url;
}

function prefetchProductCardVariantImages(root = document) {
  root.querySelectorAll('.pcard [data-variant-image]').forEach(el => {
    prefetchProductCardImage(el.dataset.variantImage);
  });
}

function setProductCardVariantImage(card, imageUrl) {
  if (!card || !imageUrl) return;

  const slideWrapper = card.querySelector('[data-variant-img-wrapper]');
  const imgEl =
    slideWrapper?.querySelector(':scope > .aspectholder img') ||
    slideWrapper?.querySelector('img') ||
    card.querySelector('.pcard__carousel img, .card__image img');
  if (!imgEl) return;

  prefetchProductCardImage(imageUrl);

  imgEl.src = imageUrl;
  imgEl.removeAttribute('srcset');
  imgEl.removeAttribute('sizes');

  const sw = card.querySelector('.swiper')?.swiper;
  if (sw) sw.slideTo(0);
}

// Warm colour-variant images once a card is near the viewport
function observeProductCardImagePrefetch(root = document) {
  const cards = root.querySelectorAll('.pcard');
  if (!cards.length) return;

  if (!('IntersectionObserver' in window)) {
    prefetchProductCardVariantImages(root);
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        prefetchProductCardVariantImages(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '200px 0px' }
  );

  cards.forEach(card => observer.observe(card));
}

window.prefetchProductCardVariantImages = prefetchProductCardVariantImages;
window.observeProductCardImagePrefetch = observeProductCardImagePrefetch;

document.addEventListener('DOMContentLoaded', () => {
  observeProductCardImagePrefetch();
});

// Prefetch on swatch hover/focus so the click often hits cache
document.addEventListener(
  'pointerenter',
  e => {
    const pill = e.target.closest?.('.pcard [data-variant-image]');
    if (pill?.dataset.variantImage) {
      prefetchProductCardImage(pill.dataset.variantImage);
    }
  },
  true
);

// Event delegation so colour swatches work on AJAX-loaded cards (e.g. product recs)
document.addEventListener('click', e => {
  const pill = e.target.closest?.('.variant-pill');
  if (!pill) return;

  const card = pill.closest('.pcard');
  if (!card) return;

  e.preventDefault();

  const pills = card.querySelectorAll('.variant-pill');
  const value = pill.dataset.value;
  const imageFromSwatch = pill.dataset.variantImage;

  pills.forEach(p => p.classList.remove('active'));
  pill.classList.add('active');

  // Prefer image URL baked onto the swatch (works even if product JSON is missing/broken)
  if (imageFromSwatch) {
    setProductCardVariantImage(card, imageFromSwatch);
  }

  const productDataEl = card.querySelector('.product-json');
  if (!productDataEl) return;

  let product;
  try {
    product = JSON.parse(productDataEl.textContent);
  } catch {
    return;
  }

  if (!Array.isArray(product.options)) return;

  const plpCard = card.closest('[data-plp-card]');
  const sizeValue = (plpCard?.dataset.size || '').trim().toLowerCase();
  if (sizeValue && Array.isArray(product.variants)) {
    product = {
      ...product,
      variants: product.variants.filter((variant) => {
        const options = [variant.option1, variant.option2, variant.option3].filter(
          (option) => option != null && option !== ''
        );
        const values = options.length ? options : variant.options || [];
        return values.some(
          (option) => String(option || '').trim().toLowerCase() === sizeValue
        );
      })
    };
  }

  if (plpCard && Array.isArray(product.variants)) {
    const colourKeys = Array.from(plpCard.querySelectorAll('[data-plp-colour]'))
      .map((node) => (node.dataset.value || '').trim().toLowerCase())
      .filter(Boolean);
    const colourOptionIndex = getProductCardColourOptionIndex(product.options);
    if (colourKeys.length && colourOptionIndex !== -1) {
      const optionKey = `option${colourOptionIndex + 1}`;
      product = {
        ...product,
        variants: product.variants.filter((variant) =>
          colourKeys.includes(String(variant[optionKey] || '').trim().toLowerCase())
        )
      };
    }
  }

  const colourOptionIndex = getProductCardColourOptionIndex(product.options);
  if (colourOptionIndex === -1) return;

  const variant = findProductCardVariantForColour(
    product,
    colourOptionIndex,
    value
  );

  if (!variant) return;

  updateProductCardPrice(card, variant, product);

  if (!imageFromSwatch && variant.featured_image?.src) {
    setProductCardVariantImage(card, variant.featured_image.src);
  }
});

// Upsell / featured cards: swap image when the variant select changes
document.addEventListener('change', e => {
  const select = e.target.closest?.('.pcard__variant-select');
  if (!select) return;

  const card = select.closest('.pcard');
  if (!card) return;

  const productDataEl = card.querySelector('.product-json');
  if (!productDataEl) return;

  let product;
  try {
    product = JSON.parse(productDataEl.textContent);
  } catch {
    return;
  }

  const variant = product.variants?.find(
    v => String(v.id) === String(select.value)
  );
  if (!variant) return;

  const imgEl = card.querySelector('.card__image img, .pcard__carousel img');
  if (imgEl && variant.featured_image?.src) {
    imgEl.src = variant.featured_image.src;
    imgEl.removeAttribute('srcset');
  }

  const btn = card.querySelector('.pcard__simple-atc-btn');
  if (btn) {
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
  }
});

// Dark bg partners tabbing section
document.addEventListener('DOMContentLoaded', () => {
  const partnerSections = document.querySelectorAll(
    '[data-partners-section]'
  );

  partnerSections.forEach(section => {
    const sectionId = section.getAttribute('data-partners-section');
    const dataEl = document.querySelector(
      `[data-partner-json="${sectionId}"]`
    );
    if (!dataEl) return;

    const data = JSON.parse(dataEl.textContent);

    const tabs = section.querySelectorAll('[data-partner-tab]');
    const imgEl = section.querySelector('[data-partner-image]');
    const logoEl = section.querySelector('[data-partner-logo] img');
    const bodyEl = section.querySelector('[data-partner-body]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-partner-tab');
        const item = data[id];

        // Update active state
        tabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');

        // Update image, logo, body
        if (item.image && imgEl) imgEl.src = item.image;
        if (item.logo && logoEl) logoEl.src = item.logo;
        if (item.body && bodyEl) bodyEl.innerHTML = item.body;
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('hubspot-form-modal');
  if (!modal) return;

  const container = document.getElementById('hubspot-form-container');
  const closeBtn = modal.querySelector('.hubspot-modal__close');

  function loadHubSpot(callback) {
    if (window.hbspt) {
      callback();
      return;
    }

    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  function openModal() {
    modal.classList.add('active');
  }

  function closeModal() {
    modal.classList.remove('active');
    container.innerHTML = '';
  }

  closeBtn.addEventListener('click', closeModal);

  // Button trigger handler
  document.addEventListener('click', e => {
    const btn = e.target.closest('.open-hubspot-form');
    if (!btn) return;

    const formId = btn.dataset.formId;
    const portalId = btn.dataset.portalId || '143444228';

    loadHubSpot(() => {
      hbspt.forms.create({
        region: 'eu1',
        portalId,
        formId,
        target: '#hubspot-form-container'
      });
      openModal();
    });
  });
});

function initB2BFiles() {
  const folders = document.querySelectorAll('.b2b-folder');
  if (!folders.length) return;

  // Folder toggle
  document.querySelectorAll('.folder-toggle').forEach(btn => {
    btn.addEventListener('click', function () {
      const folder = this.closest('.b2b-folder');
      folder.classList.toggle('is-open');
      this.textContent = folder.classList.contains('is-open')
        ? 'Close'
        : 'Open';
    });
  });

  // Filtering
  const filterButtons = document.querySelectorAll('.filter-btn');

  filterButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      filterButtons.forEach(b => b.classList.remove('is-active'));
      this.classList.add('is-active');

      const filter = this.dataset.filter;
      const cards = document.querySelectorAll('.b2b-file-card');

      cards.forEach(card => {
        if (filter === 'all' || card.dataset.type === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
}

function initB2BNotification() {
  const bubble = document.getElementById('b2b-notification');
  if (!bubble) return;

  const isB2B = document.body.dataset.customerB2b === 'true';
  const dismissed = sessionStorage.getItem(
    'b2bNotificationDismissed'
  );

  if (!isB2B || dismissed === 'true') return;

  setTimeout(() => {
    bubble.classList.add('is-visible');
  }, 300);

  const closeBtn = document.getElementById('b2b-notification-close');

  closeBtn?.addEventListener('click', () => {
    bubble.classList.add('is-exiting');

    setTimeout(() => {
      bubble.remove();
    }, 300);

    sessionStorage.setItem('b2bNotificationDismissed', 'true');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initB2BFiles();
  initB2BNotification();
});
